import MentionsOfficialAccountPostRoute from './MentionsOfficialAccountPostRoute';

export default MentionsOfficialAccountPostRoute;
